import get from 'lodash/get'

import API from 'api'
import globalRequest from 'common/utils/globalRequest'
import AboutBoa from 'components/quote/aboutBoa'
import QuoteLayout from 'layouts/QuoteLayout'


export async function getServerSideProps({ locale, query }) {
  const quoteData = await API.get(`api/v2/public/quotes/${query.id}`, { headers: { 'Accept-Language': locale } }).catch(() => null)
  if(!quoteData) {
    return { notFound: true }
  }
  const defaultValues = await globalRequest(locale)
  const aboutLink = get(defaultValues, `cmsInfo.data.about_bl_slug.${locale}`, 'de')
  const [ pageData, utmData ] = await Promise.all([
    API.get(`api/v1/pages/${aboutLink}`, { headers: { 'Accept-Language': locale } }).catch(() => null),
    API.get('api/v1/info', { headers: { 'Accept-Language': locale } }).catch(() => ({ quote_utm_tags: {} })),
  ])
  if(!pageData) {
    return { notFound: true }
  }
  const initialReduxStore = {
    ...defaultValues,
    quoteList: {
      data: quoteData,
    },
    aboutBoa: {
      data: pageData,
    },
    utmData: {
      data: utmData,
    },
  }
  return { props: { initialReduxStore, withCover: true } }
}

export default function AboutBoaPage() {
  return (
    <QuoteLayout withCover>
      <AboutBoa />
    </QuoteLayout>
  )
}
